export enum GlobalActionTypes {
  MESSAGE_FAIL = 'MESSAGE_FAIL',
  CLEAR_ERRORS = 'CLEAR_ERRORS',
  SUCCESS_LOAD = 'SUCCESS_LOAD',
  LOADING = 'LOADING',
  MAP_READY = 'MAP_READY',
}

export interface MessageFailAction {
  type: GlobalActionTypes.MESSAGE_FAIL;
  payload: any;
}

export interface ClearErrorsAction {
  type: GlobalActionTypes.CLEAR_ERRORS;
}

export interface SuccessLoadAction {
  type: GlobalActionTypes.SUCCESS_LOAD;
  payload?: any;
}

export interface LoadingAction {
  type: GlobalActionTypes.LOADING;
}

export interface MapReadyAction {
  type: GlobalActionTypes.MAP_READY;
}

export type GlobalActions =
  | MessageFailAction
  | ClearErrorsAction
  | SuccessLoadAction
  | LoadingAction
  | MapReadyAction;
